import org from '../../../api/org'
import token from '../../../utils/token'

const user= {
  state: {
    expUser: {},
    userInfo: {},
    initInfo:{},
    loginId:'',
    status: '',
    code: '',
    token: token.getToken(),
    userName: '',
    avatar: '',
    introduction: '',
    roles: [],
    systemParameter:{},
    setting: {
      articlePlatform: []
    },

    unitDepartments:[],

    curUnit:[],
    curSelUnit:'',
    curSelUnitId:'',

    curDept:[],
    curSelDept:'',
    curSelDeptId:'',
    sysConfig : {}
  },

  mutations: {

    SET_EXP_USER: (state, user) => {
      state.expUser = user
    },
    SET_INIT_INFO: (state, info) => {
      state.initInfo = info
    },
    SET_USER_INFO: (state, user) => {
      state.userInfo = user;
      state.loginId=user.loginId;
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.userName = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_SYS_CONFIG:(state,sysConfig)=>{
      state.sysConfig = sysConfig;
    },
    SET_SYSTEM_PARAMETER: (state, systemParameter) => {
      state.systemParameter = systemParameter
    },

    unitDepartments: (state, unitDepartments) => {
      state.unitDepartments = unitDepartments
    },

    ['listUnit'](state, result) {
      state.curUnit=result;
      if(result && result.length>0){
        state.curSelUnitId=result[0].id
        state.curSelUnit=result[0].name
      }
    },
    ['setCurSelUnit'](state,unit) {
      state.curSelUnitId=unit.id
      state.curSelUnit=unit.name
    },
    ['listDept'](state, result) {
      state.curDept=result;
     /* if(result && result.length>0){
        state.curSelDeptId=result[0].id
        state.curSelDept=result[0].name
      }*/
    },
    ['setCurSelDept'](state,dept) {
      state.curSelDeptId=dept.id
      state.curSelDept=dept.name
    }
  },

  actions: {

    // 用户名登录
    UserLogin({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password.trim()
      return new Promise((resolve, reject) => {
        org.authenticate(username,password).then(res => {
          if (false === res.result || false === res.success) {
            resolve(res)
            return;
          }
          token.setToken(res.result);
          $xtoken=res.result;
          commit('SET_TOKEN',res.result)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    UserDeveloperLogin({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password.trim()
      return new Promise((resolve, reject) => {
        org.authenticate(username,password,true).then(res => {
          if (false === res.result || false === res.success) {
            resolve(res)
            return;
          }
          token.setToken(res.result);
          $xtoken=res.result;
          commit('SET_TOKEN',res.result)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },




    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        org.loginUserInfo().then(res => {
          if (!res || !res.result) {
            reject('error')
          }
          const data = res.result;
          let user=data.$u;
          user.data=user.data || {};
          let u=data.$u;
          u.allIdentityRoleNames = data.$allIdentityRoleNames;
          u.roleNames = data.$roleNames;
          commit('SET_USER_INFO',user);
          commit('SET_EXP_USER',data.$u);
          commit('unitDepartments',data.$unitDepartments);
          if(data.$listCurUnit)
            commit('listUnit', data.$listCurUnit)
          if(data.$listCurDept){
            commit('listDept', data.$listCurDept)
            if(data.$curDept) {
              commit('setCurSelDept',data.$curDept)
            }
          }
          if(data.$set)
            commit('SET_SYSTEM_PARAMETER',data.$set);

          let info={};
          info.inituserid=u.id;
          info.loginId=u.loginId;
          info.initusername=u.name;
          info.developer=u.developer;
          info.allIdentityRoleNames = data.$allIdentityRoleNames;
          info.roleNames = data.$roleNames;
          info.mjbs=u.mjbs;
          let dept=u.dep;
          if(dept.loginUnit){
            info.initunitid=dept.loginUnit.id;
            info.initunitname=dept.loginUnit.name;
            info.initunitshortname = dept.loginUnit.shortname || "";
          }
          if(dept.loginDept){
            info.initbmid=dept.loginDept.id;
            info.initbmname=dept.loginDept.name;
            info.initbmshortname = dept.loginDept.shortname || "";
          }
          if(u.loginDepartment){
            info.initdeptid=u.loginDepartment.id;
            info.initdeptname=u.loginDepartment.name;
            info.initdeptshortname = u.loginDepartment.shortname || "";
          }
          info.roleNames=data.$roleNames;
          info.deptIdChain=data.$deptIdChain;
          PF.userInfo=info;
          let sysConfig = {};
          _.assign(sysConfig,data.$sysConfig);
          commit('SET_SYS_CONFIG',sysConfig);
          PF._sysConfig = data.$sysConfig;

          var path=$servicePath+"/login";
          if($servicePath!='' && info.developer && window.location.href.indexOf(path)==-1){
              window.location.href=$servicePath+"/login"
          }

          commit('SET_INIT_INFO',info);
          if(u.developer)
            commit('SET_ROLES', ['admin']);
          else
            commit('SET_ROLES', ['guest']);
          commit('SET_NAME', user.name);
          commit('SET_AVATAR', user.avatar);
          commit('SET_INTRODUCTION', user.introduction);

          resolve(res);
        }).catch(error => {
          reject(error)
        })
      })
    },
    UserLogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        org.loginOut().then((res) => {
          org.clearSession().then((res) => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            token.removeToken()
            resolve()
          }).catch(error => {
            reject(error)
          })
        }).catch(error => {
          reject(error)
        })
      })
    },

    setCurSelUnit({commit}, unit) {
      commit('setCurSelUnit',unit)
    },

    setCurSelDept({commit}, dept) {
      commit('setCurSelDept',dept)
    }

  }
}

export default user



// WEBPACK FOOTER //
// ./src/common/vuex/modules/org/user.js